import React from 'react';
import { MailOutline, PhoneInTalkOutlined } from '@mui/icons-material';

export const FooterContacts: React.FC = React.memo(() => (
    <div className='footer__container__contact'>
        <ul className='footer__container__contact__list none'>
            <h4 className='footer__container__contact__title'>Contact Us:</h4>
            <li className='footer__container__contact__list__item'>
                <a
                    href='https://www.google.com/maps/place/Prispek+Consulting/@-25.6873846,28.231015,15z/data=!4m5!3m4!1s0x0:0x6d737c2de80ddf05!8m2!3d-25.6868226!4d28.2322884'
                    className='footer__container__contact__list__item__link'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    Kruin Business Centre <br /> 406 Braam Pretorius <br /> (Corner
                    of Gryshout Ave)
                    <br /> Magalieskruin
                    <br /> 0182
                </a>
            </li>
            <li className='footer__container__contact__list__item'>
                <p>P.O. Box 16, Magalieskruin, 0150</p>
            </li>
            <li className='footer__container__contact__list__item'>
                <a
                    href='mailto:service@prispek.co.za'
                    className='footer__container__contact__list__item__link'
                >
                    <MailOutline className='footer__container__contact__list__item__link__icon' />{' '}
                    service@prispek.co.za
                </a>
            </li>
            <li className='footer__container__contact__list__item'>
                <a
                    href='tel:+27125675502'
                    className='footer__container__contact__list__item__link'
                >
                    <PhoneInTalkOutlined className='footer__container__contact__list__item__link__icon' />{' '}
                    +27 12 567 5502
                </a>
            </li>
        </ul>
    </div>
));
